import React, { useEffect } from 'react';
import { Tooltip } from '@/Components/Tooltip/Tooltip';
import { PackageSelect } from '../_Shared/PackageSelect/PackageSelect';
import { FormData } from '@/ModalWindows/OrderAutomatizationModal/hooks/useOrderAutomatizationModalForm';
import { Button } from '@/Components/Controls/Button/Button';
import { globalHistory } from '@/GlobalHistory';
import { PagesRouting } from '@/Routing';
import { BUTTON_THEMES } from '@/Components/Controls/Button/ButtonThemes';
import { useContractLogisticTooltips } from '../../hooks/useContractLogisticTooltips';
import { useLocalization } from '@/Hooks';
import { OrderAutomatizaionRow } from '@/Types';
import styles from './OwnContractLogistic.scss';
import { useContractLogisticOptions } from '../../hooks/useContractLogisticOptions';
import { LogisticProductSelect } from '../_Shared/LogisticProductSelect/LogisticProductSelect';
import { LogisticProductInfo } from '../_Shared/LogisticProductInfo/LogisticProductInfo';
import { useLogisticContractForm } from '../../hooks/useLogisticContractForm';

type Props = {
  rowIndex: number;
  rowData: OrderAutomatizaionRow;
};

export const OwnContractLogistic = ({ rowIndex, rowData }: Props) => {
  const {
    modalWindows: {
      orderLinkWithProduct: {
        ShippingContract: { Activate, NoActivatedLogistics, NoActivatedPackages },
      },
    },
  } = useLocalization();

  const {
    rules: { required },
    methods: { register, errors },
    packages: { packages, append, remove },
    logisticProduct: { logisticProduct, onSelectProduct, onResetProduct },
  } = useLogisticContractForm(rowIndex);

  // Options
  const defaultCurrency = '€';
  const { productTooltipMessage } = useContractLogisticTooltips(packages);
  const { packageOptions, productOptions, isContractsConfigured } = useContractLogisticOptions(
    rowData.orderId,
    packages,
    true,
  );

  useEffect(() => {
    onResetProduct();
  }, [productOptions.length]);

  if (!packageOptions) return null;

  if (!isContractsConfigured || packageOptions.length == 0) {
    return (
      <div className={styles.logisticRow}>
        <div className={styles.noLogisticsMessage}>
          <span>{isContractsConfigured ? NoActivatedPackages : NoActivatedLogistics}</span>
          <Button
            text={Activate}
            theme={BUTTON_THEMES.PRIMARY}
            onClick={() =>
              globalHistory.push(
                isContractsConfigured
                  ? PagesRouting.SettingsPages.PackagesSettings
                  : PagesRouting.SettingsPages.LogisticSettings,
              )
            }
          />
        </div>
      </div>
    );
  }

  return (
    <div className={styles.logisticRow}>
      {packages.map((p, idx) => (
        <PackageSelect
          key={p.array_id}
          index={idx}
          rowIndex={rowIndex}
          isAddActive={packages.length < 5}
          onAdd={() => append({ key: '', weight: '' })}
          onDelete={() => remove(idx)}
          packages={packageOptions}
          disabled={rowData.hasLabelCreated}
        />
      ))}

      {!logisticProduct ? (
        <Tooltip text={productTooltipMessage} shouldShowOnHover={productOptions.length == 0}>
          <LogisticProductSelect<FormData>
            name={(`prepareLabels.${rowIndex}.userProductId` as unknown) as keyof FormData}
            register={register}
            rules={required}
            error={errors}
            products={productOptions}
            currency={defaultCurrency}
            onSelect={onSelectProduct}
            readonly={rowData.hasLabelCreated}
          />
        </Tooltip>
      ) : (
        <LogisticProductInfo product={logisticProduct} currency={defaultCurrency} onDelete={onResetProduct} />
      )}
    </div>
  );
};
